import React, { useEffect } from 'react';

import styles from './full-screen-modal.scss';
// import { string } from 'prop-types';
// import { PropTypes } from 'mobx-react';

const FullScreenModal = ({ children, className = '' }) => {
  useEffect(() => {
    document.body.classList.add(styles.freezeBody);
    /* eslint-disable no-unused-expressions */
    document.querySelector('[data-pagelet-container-id=footer-navigation]')?.classList.add(styles.hideFooter);
    return () => {
      document.body.classList.remove(styles.freezeBody);
      /* eslint-disable no-unused-expressions */
      document.querySelector('[data-pagelet-container-id=footer-navigation]')?.classList.remove(styles.hideFooter);
    };
  }, []);

  return <div className={`${styles.fullScreenModal} ${className}`}>{children}</div>;
};

// FullScreenModal.propTypes = {
//   children: PropTypes.element,
//   className: PropTypes.string,
// };

export default FullScreenModal;
